import EguMstMaterial from "./EguMstMaterial";

function EguItemInfoManagement ( props ) {
    return (
        <EguMstMaterial id="EguMstMaterial" />
    );
}

export default EguItemInfoManagement;
